const SATURATION = 65;
const LIGHTNESS = 58;
const HUE_OFFSET = 30; // avoid hue 0 (red) which blends with brand-red

/**
 * Assigns deterministic colors to collectors. Per-user DB color
 * (team_members.member_color) wins when provided via `dbColors`; remaining
 * ids fall back to evenly distributed HSL. IDs are sorted alphabetically
 * so the HSL fallback stays stable across renders.
 */
export function assignCollectorColors(
  ids: string[],
  dbColors?: Record<string, string | undefined>
): Record<string, string> {
  const sorted = [...ids].sort();
  const step = sorted.length > 0 ? 360 / sorted.length : 0;
  const colors: Record<string, string> = {};
  for (let i = 0; i < sorted.length; i++) {
    const id = sorted[i];
    if (!id) continue;
    const overridden = dbColors?.[id];
    if (overridden) {
      colors[id] = overridden;
    } else {
      const hue = (HUE_OFFSET + Math.round(step * i)) % 360;
      colors[id] = `hsl(${hue}, ${SATURATION}%, ${LIGHTNESS}%)`;
    }
  }
  return colors;
}

export function getCollectorColor(
  colorMap: Record<string, string>,
  id: string
): string {
  return colorMap[id] ?? `hsl(0, ${SATURATION}%, ${LIGHTNESS}%)`;
}
